import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_PathwayState = {
    _v1: {
        deletePathwayState: { method: HttpMethod.POST, path: '/v1/pathway-state/delete-pathway-state' },
        detachStateContext: { method: HttpMethod.POST, path: '/v1/pathway-state/detach-state-context' }
    }
};
//# sourceMappingURL=api-def.js.map